import React, { useState, useRef, useEffect } from 'react'
import { LanguageDropdownProps } from './LanguageDropdown.types'
import { LANGUAGES } from '../../i18n/constants'

const defaultLanguages = LANGUAGES

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  currentLang,
  onLanguageChange,
  languages = defaultLanguages,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [triggerWidth, setTriggerWidth] = useState(0)
  const triggerRef = useRef<HTMLDivElement>(null)

  const currentLanguage = languages.find((lang) => lang.code === currentLang)

  useEffect(() => {
    if (triggerRef.current) {
      setTriggerWidth(triggerRef.current.offsetWidth)
    }
  }, [isOpen, currentLang])

  return (
    <div className="relative">
      {/* Button */}
      <div
        ref={triggerRef}
        className="flex items-center justify-between px-3 sm:px-4 py-3 sm:py-2.5 cursor-pointer bg-[var(--lang-bg)] text-[var(--lang-text)] hover:bg-[var(--bet-type-hover-bg)] hover:border-[var(--bet-type-hover-border)] border border-transparent"
        style={{
          borderRadius: 'var(--custom-radius-sm)',
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {/* Left side: Flag and Text */}
        <div className="flex items-center">
          {currentLanguage?.flag && (
            <img
              src={currentLanguage.flag}
              alt={`${currentLanguage.label} flag`}
              className="w-5 h-4 sm:w-6 sm:h-5 mr-1.5 sm:mr-2 rounded-sm object-contain"
            />
          )}
          <span className="text-xs sm:text-sm font-semibold">
            {currentLang?.toUpperCase()}
          </span>
        </div>

        {/* Right side: Caret Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3 sm:h-4 sm:w-4 ml-2 flex-shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div
          className="absolute top-12 right-0 bg-[var(--lang-dropdown-bg)] rounded shadow-lg z-10 py-1 sm:py-0"
          style={{ width: triggerWidth }}
        >
          {languages
            .filter((lang) => lang.code !== currentLang)
            .map((lang) => (
              <div
                key={lang.code}
                className="flex items-center px-3 sm:px-4 py-2 sm:py-2 text-[var(--lang-text)] hover:bg-[var(--bet-type-hover-bg)] hover:border-[var(--bet-type-hover-border)] hover:rounded cursor-pointer text-xs sm:text-sm border border-transparent"
                onClick={() => {
                  onLanguageChange(lang.code)
                  setIsOpen(false)
                }}
              >
                {lang.flag && (
                  <img
                    src={lang.flag}
                    alt={`${lang.label} flag`}
                    className="w-5 h-4 sm:w-6 sm:h-5 mr-1.5 sm:mr-2 rounded-sm object-contain"
                  />
                )}
                {lang.label}
              </div>
            ))}
        </div>
      )}
    </div>
  )
}

export default LanguageDropdown
